import React, {
  useEffect,
  useRef,
  useState,
  useContext
} from "react";
import { useLocation, Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import ComedyBreadCrumb from "../comedyBreadCrumb";
import Skeleton from "../skeleton";
import { DeviceContext } from "..";
import "../../../styles/comedyVideosList.css";
import ComedyVideosListCard from "./card";
import PageAds from "../../common/pageAds";



const ComedyVideosList = ({ data }) => {

  /* ---------------- SSR DATA ---------------- */
  const ssrData =  data?.[0]?.videosListPage || {};
  const ssrCards = ssrData.videosListData || [];
  const ssrCatId = ssrData.ssrVCatId;

  /* ---------------- STATE ---------------- */
  const [dataList, setDataList] = useState(ssrCards);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [hydrating, setHydrating] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages] = useState(40);

  const { mobile, setMobile,containerRef } = useContext(DeviceContext);

  /* ---------------- ROUTE ---------------- */
  const location = useLocation();
  const address = location.pathname;

  const matchId = address.match(/-(\d+)\.html$/);
  const vCatId = matchId ? matchId[1] : null;

  /* ---------------- REFS ---------------- */
  const firstRenderRef = useRef(true);
  const catIdRef = useRef(vCatId);

  /* ---------------- HELPERS ---------------- */
  const isTelugu = (text) => /[\u0C00-\u0C7F]/.test(text);

  /* ---------------- HYDRATION ---------------- */
  useEffect(() => {
    const t = setTimeout(() => setHydrating(false), 500);
    return () => clearTimeout(t);
  }, []);

  /* ---------------- BREADCRUMB ---------------- */

    
 const VIDEOSLIST_CATEGORIES = [
  { id: 25, text: "Erri Dippa" },
  { id: 26, text: "Spoofs" },
  { id: 6, text: "Mallik Comedy" },
  { id: 5, text: "Shhh Gup Chip" },
  { id: 4, text: "Happy Happyga" },
  { id: 14, text: "Telugu Comedy Videos" },
  { id: 31, text: "Archives" },

];

const breadCrumb = React.useMemo(() => {
  const match = VIDEOSLIST_CATEGORIES.find(
    item => String(item.id) === String(vCatId)
  );

  return match
    ? { one: match.text, two: "" }
    : { one: "", two: "" };
}, [vCatId]);


  /* ---------------- CATEGORY CHANGE ---------------- */
  useEffect(() => {
    if (catIdRef.current !== vCatId) {
      catIdRef.current = vCatId;
      setPage(1);
      setDataList([]);
      setError(null);
    }
  }, [vCatId]);

  /* ---------------- DATA FETCH ---------------- */
  useEffect(() => {

    
    if (
      hydrating &&
      firstRenderRef.current &&
      String(vCatId) === String(ssrCatId) &&
      ssrCards.length
    ) {
      firstRenderRef.current = false;
      return;
    }

    const fetchData = async () => {
      setLoading(true);
      try {
        setMobile(window.innerWidth <= 768);
        const limit = window.innerWidth <= 768 ? 8 : 12;
        const start = (page - 1) * limit;

        const res = await fetch(
          `https://www.teluguone.com/comedy/comedyVideoCategoryJson.php?start=${start}&limit=${limit}&vcat_id=${vCatId}`
        );

        if (!res.ok) throw new Error("API failed");

        const result = await res.json();
        setDataList(result.comedy_video_category || []);
        setError(null);

      } catch (err) {
        setError(err.message);
        setDataList([]);
      } finally {
        setLoading(false);
      }
    };

    firstRenderRef.current = false;
    fetchData();

  }, [vCatId, page, hydrating]);

  /* ---------------- PAGINATION ---------------- */
  const renderPagination = () => {
    if (!totalPages) return null;
    const pagesPerBlock = 5;
    const startPage = Math.floor((page - 1) / pagesPerBlock) * pagesPerBlock + 1;
    const endPage = Math.min(startPage + pagesPerBlock - 1, totalPages);
    const pages = [];

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <button
          key={i}
          className={`videosList-pagination-btn ${i === page ? "videosList-cat-page-active" : ""}`}
          onClick={() => setPage(i)}
        >
          {i}
        </button>
      );
    }

    return (
      <div className="videosList-cat-pagination">
        <button
          className={`${page !== 1 ? 'videosList-cat-pagination-arrow' : ''}`}
          onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
          disabled={page === 1}
        >
          &laquo; Prev
        </button>

        {pages}

        <button
          className="videosList-cat-pagination-arrow"
          onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
          disabled={page === totalPages}
        >
          Next &raquo;
        </button>
      </div>
    );
  };

  /* ---------------- RENDER ---------------- */
  return (
    <div className="comedy-videosList-page" style={{minHeight: `${(dataList && dataList.length > 6) ? '800px' : '400px' }`}}>

      <Helmet>
        <title>Funny Videos | Telugu Funny videos | Telugu Funny Video Clips - TeluguOne Videos</title>
      </Helmet>

      <ComedyBreadCrumb breadCrumb={breadCrumb} />
       {(loading || hydrating) && !mobile &&
            Array(mobile ? 8 : 12)
              .fill("0")
              .map((__, index) => (
                
                  <div className="comedy-videosList-card" key={index}>
                    
                    <img
                      src="/comedy/assets/images/error_img.webp"
                      alt="small-img"
                      className="comedy-videosList-card-img"
                    />
                   <Skeleton type="title" />
                  </div>
              
              ))}

           {(loading) && mobile &&  Array(mobile ? 8 : 12).fill('0').map((__,index) => 
                              
                                
                                      <div className='comedy-videosList-mob-card' key={index}> 
                                         <div className='comedy-videosList-mob-card-img-container'>
                                             <img  src={`/comedy/assets/images/error_img.webp`} alt="comedy-videosList-mob-card-img" />
                                         </div> 
                                          <div className='d-flex flex-column  comedy-videosList-mob-card-title-container'>
                                               <Skeleton type={'title'} />
                                              <Skeleton type={'paragraph'} />
                                          </div>
                                    </div>
                                
                            )} 

      {!loading && dataList.length > 0 &&
        dataList.map((item, index) =>
          item.msg ? null : mobile ? (
                            <div className={`comedy-videosList-mob-card ${hydrating ? 'ssr-hidden' : ''}`} key={index} >
                            
                             <Link to={item.url_link ? item.url_link.substring(item.url_link.indexOf('/videodetails')) : ''}  >
                           
                                <div className='comedy-videosList-mob-card-img-container'>
                                <img   loading={ index === 0 ? "eager" : index < 4 ? "auto" : "lazy"}
                       fetchpriority={index === 0 ? "high"  : index < 4 ? "auto"  : "low" } src={item.stimg ? item.stimg : '/comedy/assets/images/error_img.webp'} alt="comedy-videosList-mob-card-img" />
                                </div>
                                <div className='comedy-videosList-mob-card-title-container'>
                                <h4 className={`comedy-videosList-mob-card-title ${isTelugu(item.vgal_title) && item.vgal_title ? "comedy-videosList-mob-card-title-tl" : 'comedy-videosList-mob-card-title-en'}`}>{item.vgal_title ? item.vgal_title : ''}</h4>
                                <p    dangerouslySetInnerHTML={{__html : (item.description ? item.description : '')}} />{<button type='button'>View Content</button>}</div>
                              
                             
                             </Link>
                         
                         
                   </div>
          ) : (
            <ComedyVideosListCard key={index} item={item} index={index} />
          )
        )
      }

      {!loading && !error && !hydrating && dataList.length === 0 && (
        <p className="no-more">No More Data......</p>
      )}

      {!loading &&
        ((mobile && dataList.length === 8) ||
          (!mobile && dataList.length === 12)) &&
        renderPagination()
      }

      {error && <div className="json-loading-error-div">
                                  <img loading="eager" src="/comedy/assets/images/json_error.png" alt="json_error" />
                              </div>}
       <PageAds  mobile={mobile} containerRef={containerRef} /> 
    </div>
  );
};

export default ComedyVideosList;
